import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InteractedPeopleComponent} from './interacted-people.component';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';
import {IonicModule} from '@ionic/angular';

@NgModule({
  declarations: [InteractedPeopleComponent],
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    IonicModule
  ],
  exports: [InteractedPeopleComponent]
})
export class InteractedPeopleModule {
}
